export function GameRow({ row, squares, setSquares }) {

  const onSquareClick = (loc) => {
    let newSquares = [...squares];
    let square = newSquares[loc]

    switch (square.state) {
      case "correct":
        square.state = "unknown";
        break;
      case "misplaced":
        square.state = "correct";
        break;
      case "unknown":
        square.state = "excluded";
        break;
      case "excluded":
        square.state = "misplaced";
        break;
      default:
        square.state = "unknown";
        break;
    }

    newSquares[loc] = square;
    setSquares(row, newSquares);
  }

  return (
    <div className="flex space-x-1.5 justify-center items-center">
      {squares.map((square) => (
        // Game Square
        <GameSquare key={`${row}-${square.loc}`} square={square} onClick={onSquareClick} />
      ))}
    </div>

  )
}

function GameSquare({ square, onClick }) {
  let style = ""
  switch (square.state) {
    case "correct":
      style = "bg-green-500 text-white";
      break;
    case "misplaced":
      style = "bg-yellow-500 text-white";
      break;
    case "excluded":
      style = "bg-gray-500 text-white";
      break;
    default:
      style = "bg-white text-black border-2 border-gray-300";
      break;
  }

  return (
    <div onClick={() => onClick(square.loc)} className={`${style} select-none flex w-14 h-14 rounded-sm items-center justify-center uppercase text-4xl transition-colors ease-in-out`}>
      {square.letter}
    </div>
  )
}